<template>
    <div>
        <template v-if="report.reporttype == 'keyvalue'">
            <h2>{{report.name}}</h2>

            <h2 :style="{color: report.color}">{{report.data}}</h2>
        </template>

        <template v-else-if="report.reporttype == 'list'">
            <v-data-table
                :headers="headers"
                :items="items"
                item-key="name"
                @click:row="rowClick"
            >
                <template v-slot:item.image="{ item }">
                    <img :src="$api.getImageUrl(item.image, 50)" width="50" height="50" class="mt-2" />
                </template>

            </v-data-table>
        </template>

        <!-- <div>{{JSON.stringify(report)}}</div> -->
    </div>
</template>

<script>
export default {
    name: 'zoezi-report',

    zoezi: {
        title: 'Report',
        icon: 'mdi-chart-line'
    },

    props: {
        reportId: {
            title: 'Report',
            type: Number,
            fulltype: 'select',
            typeinfo: {
                multiple: false,
                text: 'name',
                value: 'id',
                getItems: () => window.$zoeziapi.get('/api/stats/generic/reports/get').then(reports => { reports.forEach(r => r.name = window.$translate(r.data.name)); return reports; })
            }
        },
        userClickLink: {
            title: 'Page to go to when clicking on user',
            type: String,
            fulltype: 'page'
        }
    },

    data: () => ({
        report: {},
        info: null
    }),

    computed: {
        headers() {
            if (!this.report || this.report.reporttype != 'list' || !this.info) {
                return [];
            }

            return this.report.properties.map(prop => {
                return {
                    text: this.getPropName(prop, this.report.datatype),
                    value: prop
                }
            });
        },
        items() {
            if (!this.report || this.report.reporttype != 'list' || !this.info) {
                return [];
            }

            return this.report.data;
        },
        userHasPermission() {
            return this.$api.hasPermission('Show customers') || this.$api.hasPermission('Show statistics');
        }
    },

    watch: {
        reportId: {
            immediate: true,
            handler() {
                this.getReport();
            }
        },
        userHasPermission: {
            immediate: true,
            handler() {
                if (this.userHasPermission) {
                    this.getInfo();
                    this.getReport();
                }
            }
        }
    },

    methods: {
        getReport() {
            if (!this.reportId || !this.userHasPermission) {
                this.report = {};
                return;
            }
            let data = {report_id: this.reportId}
            this.$api.post('/api/stats/generic', data).then(response => response.json().then(report => {
                this.report = report;
            }))
        },
        getInfo() {
            if (!this.userHasPermission) {
                return;
            }
            this.$api.get('/api/stats/generic/info').then(info => {
                this.info = info;
            });
        },
        getPropName(name, datatype) {
            let res = '';

            let parts = name.split('.');
            let prop;
            parts.forEach(part => {
                let props = this.info.properties[datatype];
                prop = props.find(p => p.id == part);
                if (res) {
                    res += ' > ';
                }
                res += this.$translate(prop.name);
                datatype = prop.joinedproperty;
            })
            return res;
        },
        rowClick(item) {
            this.$router.push({path: `${this.userClickLink}/${item._user_id}`});
        }
    }
}
</script>
